/**
 * Snippets API
 * Here is the API DNA
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { GuidedTour } from './guidedTour';

export interface UserDtoPartialUpdate {
  firstName?: string;
  lastName?: string;
  language?: UserDtoPartialUpdate.LanguageEnum;
  guidedTour?: GuidedTour;
  organization?: number;
}
export namespace UserDtoPartialUpdate {
  export type LanguageEnum = 'fr' | 'nl';
  export const LanguageEnum = {
    Fr: 'fr' as LanguageEnum,
    Nl: 'nl' as LanguageEnum,
  };
}
